export const apiURL = process.env.REACT_APP_API_URL;
export const pyApiURL = process.env.REACT_APP_PYTHON_APi_URL;
export const isPolyREST = process.env.REACT_APP_REST_DATA === "POLY";
export const isInternalWS = process.env.REACT_APP_WS_DATA === "INTERNAL";
export const wsUrl = "https://ws.tradealgo.com/cometd";
// process.env.REACT_APP_WS_URL
